export const MASTERDATA = '/masterdata/banks';
export const MASTERDATAPOSITION = '/masterdata/positions';
export const MASTERDATATRANSACTIONTYPE = '/masterdata/transactiontypes';
export const MASTER_DATA = '/masterData';